import { useQuery } from "@tanstack/react-query";
import { apiFetch } from "../APIClient";
import { GetEventsResponseDto } from "../generated/generatedTypes";
import { getApiErrorMessage } from "../getApiErrorMessage";

export const useGetEvents = () => {
  return useQuery<GetEventsResponseDto>({
    queryKey: ["events", "admin"],
    queryFn: async () => {
      const response = await apiFetch("api/admin/events");
      if (!response.ok) {
        throw new Error(await getApiErrorMessage(response));
      }
      return response.json();
    },
  });
};
